import { observer } from 'mobx-react-lite';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import AnnualBillingPage from '../pages/AnnualBillingPage';
import BookingsPage from '../pages/BookingsPage';
import ContactsPage from '../pages/ContactsPage';
import DamageReportPage from '../pages/DamageReportPage';
import DocumentsPage from '../pages/DocumentsPage';
import LoginPage from '../pages/LoginPage';
import MessagesPage from '../pages/MessagesPage';
import MyDataPage from '../pages/MyDataPage';
import ReservationsPage from '../pages/ReservationsPage';
import StartPage from '../pages/StartPage';
import UnreadDocumentsPage from '../pages/UnreadDocumentsPage';
import { useStore } from '../store/context';

import MainLayout from '../layouts/MainLayout';
import BlackboardPage from '../pages/BlackboardPage';
import ConsultationDaysPage from '../pages/ConsultationDaysPage';
import HomeInsurancePage from '../pages/HomeInsurancePage';
import NewsPage from '../pages/NewsPage';
import OilPricesPage from '../pages/OilPricesPage';
import RedeemPasswordPage from '../pages/RedeemPasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';

const RequireAuth = observer(() => {
  const location = useLocation();

  const { authStore } = useStore();

  if (!authStore.userData?.success) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <MainLayout />;
});

const Router: React.FunctionComponent = observer(() => (
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/passwort-link-anfordern" element={<ResetPasswordPage />} />
      <Route
        path="/passwort-zuruecksetzen/:resetToken"
        element={<RedeemPasswordPage />}
      />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<StartPage />} />
        <Route path="/ansprechpersonen" element={<ContactsPage />} />
        <Route path="/dokumente" element={<DocumentsPage />} />
        <Route path="/ungelesene-dokumente" element={<UnreadDocumentsPage />} />
        <Route path="/schadensmeldungen" element={<DamageReportPage />} />
        <Route path="/kontoauszug" element={<BookingsPage />} />
        <Route path="/meine-daten" element={<MyDataPage />} />
        <Route path="/jahresabrechnung" element={<AnnualBillingPage />} />
        <Route path="/reservierungen" element={<ReservationsPage />} />
        <Route path="/mitteilungen" element={<MessagesPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/schwarzes-brett" element={<BlackboardPage />} />
        <Route path="/oil-prices" element={<OilPricesPage />} />
        <Route path="/sprechtage" element={<ConsultationDaysPage />} />
        <Route path="/haushaltsversicherung" element={<HomeInsurancePage />} />
      </Route>
      <Route path="*" element={<LoginPage />} />
    </Routes>
  </BrowserRouter>
));

export default Router;
